<template>
  <div v-if="publicPoll">
    <SnackBarSuccess
      ref="successSnackbar"
      position="top"
      :msg="successSnackbarMsg"
    ></SnackBarSuccess>
    <ErrorSnackbar
      ref="errorSnackbar"
      position="top"
      :msg="errorSnackbarMsg"
    ></ErrorSnackbar>
    <center>
      <v-progress-circular
        v-show="!publicPoll"
        :size="80"
        :width="6"
        color="#007E7A"
        indeterminate
      >
      </v-progress-circular>
    </center>
    <div class="img-slider" v-show="publicPoll">
      <v-img
        :src="
          publicPoll &&
          publicPoll.data &&
          publicPoll.data.photos &&
          publicPoll.data.photos.slider
            ? publicPoll.data.photos.slider
            : 'https://prosas.com.br/img/noimagecapa.png'
        "
      >
      </v-img>
    </div>

    <v-row class="divider-central">
      <v-row class="maxwidth">
        <div class="data-title">
          {{ publicPoll && publicPoll.data ? publicPoll.data.name : "" }}
        </div>

        <div class="data-description">
          <div
            class="data-description-content"
            v-html="
              publicPoll && publicPoll.data ? publicPoll.data.description : ''
            "
          ></div>
        </div>
      </v-row>
    </v-row>

    <!-- ABERTURA/ENCERRADA - DATAS -->
    <v-card id="votingcard" v-if="votingPortal" class="d-flex justify-center">
      <v-sheet
        v-if="onTimeToVoting === 'not_publish'"
        class="votingcardinfo text-center"
      >
        <p>A votação será publicada em:</p>
        <h3>
          {{ formatDate(publicPoll.configuration.publicationDate) }}
        </h3>
        <label class="lbl-hour-description"
          >GMT-03 (Horário Padrão de Brasília)</label
        >
      </v-sheet>

      <v-sheet
        v-else-if="onTimeToVoting === 'before'"
        class="votingcardinfo text-center"
      >
        <p>A votação iniciará em:</p>
        <h3>
          {{
            formatDate(
              publicPoll.configuration.deadlineForVotingOnProjects.from
            )
          }}
        </h3>
        <label class="lbl-hour-description"
          >GMT-03 (Horário Padrão de Brasília)</label
        >
      </v-sheet>

      <v-sheet
        v-else-if="onTimeToVoting === 'on_time'"
        class="votingcardinfo text-center"
      >
        <p>Votação aberta:</p>
        <h3>
          {{
            formatDate(
              publicPoll.configuration.deadlineForVotingOnProjects.from
            )
          }}
          <span>até</span>
          {{
            formatDate(publicPoll.configuration.deadlineForVotingOnProjects.to)
          }}
        </h3>
        <label class="lbl-hour-description"
          >GMT-03 (Horário Padrão de Brasília)</label
        >
      </v-sheet>

      <v-sheet
        v-else-if="onTimeToVoting !== 'ignore'"
        class="votingcardinfo text-center"
      >
        <p>Votação encerrada em:</p>
        <h3
          v-if="
            publicPoll.configuration.deadlineForVotingOnProjects !== undefined
          "
        >
          {{
            formatDate(publicPoll.configuration.deadlineForVotingOnProjects.to)
          }}
        </h3>
        <label class="lbl-hour-description"
          >GMT-03 (Horário Padrão de Brasília)</label
        >
      </v-sheet>
    </v-card>

    <v-row class="row-grey row-no-border">
      <article class="maxwidth contentheight">
        <v-progress-circular
          v-if="
            pollPublicProjects === null || pollPublicProjects.length === 0
          "
          :size="40"
          :width="6"
          color="#007E7A"
          indeterminate
        ></v-progress-circular>

        <v-row justify="end" v-if="publicPoll.configuration.projectDataForDisplay.projectStatus">
          <v-col cols="4">
            <v-combobox
              v-model="statusFilter"
              :items="statusList"
              @change="changeItemList"
              chips
              clearable
              label="Filtrar por status"
              multiple
              prepend-icon="mdi-filter-variant"
              solo
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-if="statusFilter.includes(item)"
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  @click="select"
                  @click:close="removeItemList(item)"
                >
                  <strong>{{ item }}</strong
                  >&nbsp;
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
        </v-row>

        <v-row justify="center" class="row-no-border top-margin-up">
          <v-col
            v-for="project in pollPublicProjectsFiltered || pollPublicProjects"
            :key="project.id"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card outlined class="mx-auto my-6">
              <!-- TODO: Houve uma duplicação de código por não conseguir encontrar solução para router-link com url absoluta. Usar a tag <a> diretamente não é recomendado: Ref.: https://v3.router.vuejs.org/api/#router-link -->
              <router-link
                class="card-title-text"
                v-if="project.isProposal"
                :to="'/project-view/' + project.id"
              >
                <v-row class="bgslider">
                  <v-img v-if="project.slider" :src="project.slider"></v-img>
                </v-row>

                <v-row class="avatartitleimg">
                  <v-col cols="3" class="avatarproject">
                    <v-avatar size="85">
                      <img
                        :src="
                          project.logo
                            ? project.logo
                            : 'https://prosas.com.br/img/proposallogo.jpg'
                        "
                      />
                    </v-avatar>
                  </v-col>

                  <v-col cols="9" class="nameproject">
                    <v-row>
                      <v-card-title
                        class="card-title"
                        v-if="publicPoll.configuration.projectDataForDisplay.nameOfProject"
                      >
                        <span>{{
                          customElipssis(project.nameOfProject)
                            ? customElipssis(project.nameOfProject, 56)
                            : project.entrepreneur.name
                        }}</span>
                      </v-card-title>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-if="publicPoll.configuration.projectDataForDisplay.projectStatus">
                  <v-col id="descriptiontatus" cols="12">
                    <p class="nonothing">
                      <!-- INSERIR A VALIDAÇÃO v-if="showField('situationOfProject')" -->
                      <span class="titlestatus">Status de avaliação da proposta:</span>
                      <span
                        v-if="
                          project.status == '' ||
                          !project.status ||
                          project.status == 'p_aprovada' ||
                          project.status == 'p_reprovada' ||
                          project.status == 'em_diligencia' ||
                          project.status == 'diligencia_respondida' ||
                          project.status == 'processo_encerrado'
                        "
                        class="badge"
                      >
                        Em Análise
                      </span>
                      <span
                        v-if="
                          project.status == 'aprovada' ||
                          project.status == 'proposta_aprovada'
                        "
                        class="badge"
                      >
                        Aprovada
                      </span>
                      <span
                        v-if="
                          project.status == 'reprovada' ||
                          project.status == 'proposta_reprovada'
                        "
                        class="badge"
                      >
                        Reprovada
                      </span>
                    </p>
                  </v-col>
                </v-row>
              </router-link>
               <!-- TODO: Houve uma duplicação de código por não conseguir encontrar solução para router-link com url absoluta. Usar a tag <a> diretamente não é recomendado: Ref.: https://v3.router.vuejs.org/api/#router-link -->
              <a
                class="card-title-text"
                target="_blank"
                v-if="!project.isProposal"
                :href="'https://prosas.com.br/projetos/publico/' + project.id"
              >
                <v-row class="bgslider">
                  <v-img v-if="project.slider" :src="project.slider"></v-img>
                </v-row>

                <v-row class="avatartitleimg">
                  <v-col cols="3" class="avatarproject">
                    <v-avatar size="85">
                      <img
                        :src="
                          project.logo
                            ? project.logo
                            : 'https://prosas.com.br/img/proposallogo.jpg'
                        "
                      />
                    </v-avatar>
                  </v-col>

                  <v-col cols="9" class="nameproject">
                    <v-row>
                      <v-card-title
                        class="card-title"
                        v-if="publicPoll.configuration.projectDataForDisplay.nameOfProject"
                      >
                        <span>{{
                          customElipssis(project.nameOfProject)
                            ? customElipssis(project.nameOfProject, 56)
                            : project.entrepreneur.name
                        }}</span>
                      </v-card-title>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row v-if="publicPoll.configuration.projectDataForDisplay.projectStatus">
                  <v-col id="descriptiontatus" cols="12">
                    <p class="nonothing">
                      <!-- INSERIR A VALIDAÇÃO v-if="showField('situationOfProject')" -->
                      <span class="titlestatus">Status de avaliação da proposta:</span>
                      <span
                        v-if="
                          project.status == '' ||
                          !project.status ||
                          project.status == 'em_diligencia' ||
                          project.status == 'p_aprovada' ||
                          project.status == 'p_reprovada'
                        "
                        class="badge"
                      >
                        Em Análise
                      </span>
                      <span
                        v-if="
                          project.status == 'aprovada' ||
                          project.status == 'proposta_aprovada'
                        "
                        class="badge"
                      >
                        Aprovada
                      </span>
                      <span
                        v-if="
                          project.status == 'reprovada' ||
                          project.status == 'proposta_reprovada'
                        "
                        class="badge"
                      >
                        Reprovada
                      </span>
                    </p>
                  </v-col>
                </v-row>
              </a>

              <div
                v-if="project.description"
                class="div-body-card padding-card principal-card-overflow"
              >
                <v-row align="center" class="mx-0"></v-row>
                <div
                  class="text-card-item"
                  v-if="
                    publicPoll.configuration.projectDataForDisplay.description
                  "
                >
                  {{
                    striphtml(project.description).substring(0, 260) + " ..."
                  }}
                </div>
                <v-row align="center" class="mx-0"></v-row>
              </div>

              <v-card-actions v-if="votingPortal">
                <v-row class="bottom-card padding-card" justify="center">
                  <div
                    class="votes-item"
                    v-if="!publicPoll.configuration.scoreAsPrivate"
                  >
                    {{ project && project.totalVotes ? project.totalVotes : 0 }}
                    <span
                      v-if="
                        project &&
                        (!project.totalVotes || project.totalVotes <= 1)
                      "
                      >Voto</span
                    >
                    <span
                      v-if="
                        project && project.totalVotes && project.totalVotes > 1
                      "
                      >Votos</span
                    >
                  </div>

                  <div class="buttonItem" v-if="onTimeToVoting === 'on_time'">
                    <FormDialogVote
                      type="button"
                      :emailRestriction="votingRestrictionByEmail"
                      :projectId="project.id"
                      @onSuccess="showSuccessAlert"
                      @onError="showErrorAlert"
                    />
                  </div>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </article>
    </v-row>

    <v-footer class="foot">
      <v-layout justify-start>
        <span class="terms"
          ><a href="https://prosas.com.br/termos" target="_blank"
            >Termos de uso e política de privacidade</a
          ></span
        >
      </v-layout>
      <v-layout justify-end>
        <span class="copy">Copyright 2022 &copy; Prosas</span>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FormDialogVote from "@/components/form/voteonTheProject/VoteForm.vue";
import SnackBarSuccess from "@/components/utils/SnackbarSuccess";
import ErrorSnackbar from "@/components/utils/SnackbarError";
import moment from "moment";
import { getBRDateTime } from "@/utils/DateUtils";

export default {
  name: "Welcome",
  components: {
    FormDialogVote,
    SnackBarSuccess,
    ErrorSnackbar,
  },
  beforeCreate() {
    const domain = this.$route.params.domain;
    this.$store.dispatch("getPublicPoll", { domain: domain });
  },
  computed: {
    ...mapState(["publicPoll", "pollPublicProjects"]),
    votingRestrictionByEmail() {
      return this.publicPoll.configuration.votingRestrictionByEmail;
    },
    votingPortal() {
      return (
        this.publicPoll && this.publicPoll.data.pageType === "VOTING_PORTAL"
      );
    },
    onTimeToVoting() {
      if (
        !this.publicPoll ||
        !this.publicPoll.configuration ||
        this.publicPoll.data.pageType !== "VOTING_PORTAL"
      ) {
        return "ignore";
      }
      const config = this.publicPoll.configuration;
      const currentDate = new moment();
      if (currentDate.isBefore(config.publicationDate)) {
        return "not_publish";
      }
      const deadline = config.deadlineForVotingOnProjects;
      if (currentDate.isBefore(deadline.from)) {
        return "before";
      }
      if (currentDate.isBetween(deadline.from, deadline.to)) {
        return "on_time";
      }
      return "after";
    },
  },
  created() {
    this.domain = this.$route.params.domain;
    this.$store.dispatch("getAllPublicProjects", {
      domain: this.$route.params.domain,
    });
  },
  data: () => ({
    projectToVote: undefined,
    successSnackbarMsg: "",
    errorSnackbarMsg: "",
    statusList: ["Em Análise", "Aprovada", "Reprovada"],
    statusFilter: [],
    pollPublicProjectsFiltered: null,
    domain: "",
  }),
  methods: {
    ...mapActions(["getPublicPoll", "getAllPublicProjects"]),
    showErrorAlert: function (errorMessage) {
      this.errorSnackbarMsg = errorMessage;
      this.$refs.errorSnackbar.show();
    },
    showSuccessAlert: function (successSnackbarMsg) {
      this.successSnackbarMsg = successSnackbarMsg;
      this.$refs.successSnackbar.show();
    },
    openProsasProject(project) {
      window.open("https://prosas.com.br/projetos/" + project.id, "__blank");
    },
    striphtml(value) {
      const div = document.createElement("div");
      div.innerHTML = value;
      const text = div.textContent || div.innerText || "";
      div.innerHTML = "";
      div.remove();
      return text;
    },
    customElipssis(oldText, numberOfCharacter) {
      if (!oldText) {
        return;
      }
      if (oldText.length < numberOfCharacter) {
        return oldText;
      }

      const numberElipssis = 3;
      const stripText = this.striphtml(oldText);
      const text = stripText.substring(0, numberOfCharacter);
      const textSeparatedElipssis = text.split(".");
      if (
        textSeparatedElipssis.length > 1 &&
        textSeparatedElipssis[textSeparatedElipssis.length - 1] === ""
      ) {
        const numberOfPoints = textSeparatedElipssis.reduce(
          (base, value, index) => {
            return base + (value.trim() === "" ? 1 : 0);
          },
          0
        );
        return textSeparatedElipssis[0].padEnd(
          textSeparatedElipssis[0].length + 3,
          "."
        );
      }
      return `${text}...`;
    },
    formatDate(ISODate) {
      return getBRDateTime(ISODate);
    },
    removeItemList(item) {
      this.statusFilter.splice(this.statusFilter.indexOf(item), 1);
      this.statusFilter = [...this.statusFilter];
    },
    changeItemList(items) {
      // Check if item exists as an option (there is no conf for this on chips)
      this.statusFilter = items.filter((item) =>
        this.statusList.includes(item)
      );

      if (this.statusFilter.length === 0) {
        return (this.pollPublicProjectsFiltered = this.pollPublicProjects);
      }
      this.pollPublicProjectsFiltered = this.pollPublicProjects.filter(
        (project) => {
          let status = false;
          for (const filter of this.statusFilter) {
            switch (filter) {
              case "Em Análise":
                if (
                  project.status == '' ||
                  !project.status ||
                  project.status == 'em_diligencia' ||
                  project.status == 'p_aprovada' ||
                  project.status == 'p_reprovada'
                )
                status = true;
                break;

              case "Aprovada":
                if (
                  project.status == 'aprovada' ||
                  project.status == 'proposta_aprovada'
                )
                status = true;
                break;

              case "Reprovada":
                if (
                  project.status == 'reprovada' ||
                  project.status == 'proposta_reprovada'
                )
                status = true;
                break;
            }
          }
          return status;
        }
      );
    },
  },
};
</script>

<style scoped>
  body {
    background-color: #fbfbfb !important;
    font-family: "Source Sans Pro", sans-serif !important;
  }

  .contentheight {
    min-height: calc(100vh - 60px);
  }

  .bgslider {
    background: #007e7a;
    min-height: 45px;
    max-width: 100%;
    margin: 0;
    padding: 0 0 1px;
  }

  .lbl-hour {
    float: right;
    padding-left: 8px;
    font-size: 18px;
    vertical-align: middle;
    font-weight: bold;
    display: table-cell;
  }

  .lbl-hour-description {
    color: #415b64;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    margin: 0;
    letter-spacing: 0.2px;
    font-style: italic;
  }

  .maxwidth {
    max-width: 1182px;
    margin: 0 auto;
    width: 100%;
  }

  .principal-card-overflow {
    position: relative;
    overflow: auto;
  }

  .padding-card {
    position: relative;
    padding: 0 16px;
  }

  .open-viewer {
    position: relative;
    top: 10px;
  }

  .open-showcase {
    position: relative;
    top: 50px;
  }

  .custom-divider {
    height: 1px;
    background-color: rgba(0, 0, 0, 0.12);
    width: 100%;
  }

  .div-body-card {
    position: relative;
  }

  .votes-item {
    text-align: center;
    width: 100%;
    color: #007e7a;
    font-size: 12px;
    font-weight: 600;
    padding: 8px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .selected-projects {
    margin-top: 10px;
    font-size: 20px;
  }

  .selected-projects-sub {
    margin-top: 12px;
    font-weight: bold;
    font-size: 14px;
    color: #4b4a4f;
  }

  .padding-new-item {
    padding-top: 6px;
  }

  .text-card-item {
    font-size: 13px;
    color: #242424;
    line-height: 18px;
    padding: 10px 0 6px;
    border-top: thin solid #ccc;
  }

  .v-avatar img {
    border: 4px solid #919191;
    border-radius: 100%;
    padding: 1px;
  }

  .card-title-bloc {
    width: 100% !important;
  }

  .div-break {
    position: relative;
    height: 10px;
    width: 100px;
  }

  .line-break {
    float: left;
    position: relative;
    width: 35%;
    height: 2px;
    top: 1px;
    background-color: #9a9ca4;
  }

  .line-weight-break {
    float: left;
    position: relative;
    width: 30%;
    height: 5px;
    background-color: #4b4a4f;
  }

  .divider-central {
    background-color: #fbfbfb !important;
    border-bottom: 2px solid #d5d6d6;
    margin: 0;
  }

  .row-no-border {
    background-color: #f0f2f2 !important;
    border: 0px !important;
    border-radius: 0px !important;
  }

  .top-margin-up {
    margin-top: -40px;
  }

  .card-title-item {
    border: none !important;
    background-color: #f0f2f2 !important;
    border: 0px !important;
    border-radius: 0px !important;
  }

  .data-description {
    margin-top: 20px;
    width: 100%;
    overflow: auto;
    margin-bottom: 28px;
  }

  .data-description-content {
    display: inline;
  }

  .data-title {
    width: 100%;
    text-align: center;
    padding-top: 35px;
    font-size: 30px;
    font-weight: bold;
    text-transform: uppercase;
    color: #007e7a;
  }

  .page-type-title {
    width: 100%;
    position: relative;
    padding-top: 93px;
    text-align: left;
    font-size: 38px;
    color: #fbfbfb;
    font-weight: bold;
    text-transform: uppercase;
    padding-left: 12%;
  }

  .first-block {
    background-color: #007e7a !important;
    height: 300px;
  }

  .img-logo {
    width: 100%;
    height: 40px;
    padding: 10px;
    margin-bottom: 7px;
  }

  .height2 {
    min-height: 250px;
  }

  .row-grey {
    background-color: #f0f2f2;
    min-height: 100px;
    border-top: 2px solid #d5d6d6;
    padding-top: 25px;
  }

  .card-layout {
    border: 0px;
    background-color: #f0f2f2 !important;
  }

  .card-text {
    background-color: #f0f2f2;
    padding-top: 50px;
  }

  .avatartitleimg {
    margin: -30px 12px 0 !important;
    padding: 0;
    position: relative;
  }

  .nameproject {
    margin: 36px 0 0;
    padding: 0;
    min-height: 62px;
  }

  .avatarproject {
    margin: 0;
    padding: 0;
  }

  .avatarproject .v-avatar {
    height: auto;
    max-width: 80px;
    width: 100%;
    border: 2px solid #fff;
    background: #fff;
  }

  .degrade {
    background-image: linear-gradient(
      to top,
      rgba(55, 71, 79, 0.8),
      rgba(51, 71, 79, 0.3),
      rgba(255, 255, 255, 0.1)
    );
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 1;
    display: inline-block;
    min-height: 125px;
    max-width: 376px;
  }

  .card-title {
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;
    font-weight: 600;
    padding: 0 0 4px 12px;
    align-items: start;
    word-break: normal;
    text-align: left;
  }

  .card-title-text {
    font-size: 15px !important;
    line-height: 16px !important;
    color: #007e7a !important;
    text-decoration: none !important;
  }

  /*  */
  #votingcard {
    padding: 18px;
  }

  #votingcard .votingcardinfo p {
    color: #20c09e;
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    margin: 0;
  }

  #votingcard .votingcardinfo h3 {
    color: #415b64;
    opacity: 1;
    font-weight: 600;
    letter-spacing: -1px;
    margin: 0;
    line-height: 38px;
    font-size: 32px;
  }

  #votingcard .votingcardinfo h3 span {
    font-size: 18px;
  }

  /*  */

  .v-card__actions {
    border-top: thin solid #ccc;
    margin: 4px 12px 16px;
  }

  .terms a {
    text-transform: uppercase;
    color: white;
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 1px;
    line-height: 20px;
    text-decoration: none;
  }

  .copy {
    text-transform: uppercase;
    color: white;
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 1px;
    line-height: 20px;
  }

  .divid {
    border: 1px solid;
    width: 20%;
  }

  .pd-top20 {
    padding-bottom: 20px;
  }

  .v-sheet {
    border-radius: 0px !important;
  }

  .v-btn {
    border-radius: 0px !important;
  }

  .img-slider {
    background: #f1f1f1;
    width: 100%;
  }

  label {
    font-size: small;
  }

  .project-item {
    margin-right: 15px;
  }

  .ql-align-left {
    text-align: left;
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-align-justify {
    text-align: justify;
  }

  .ql-size-small {
    font-size: 12px;
  }

  .ql-size-large {
    font-size: 20px;
  }

  .ql-size-huge {
    font-size: 24px;
    font-weight: 900;
  }

  @media screen and (max-width: 1024px) {
    .maxwidth {
      margin: 0 5%;
      max-width: 90%;
      width: 90%;
    }

    .votingcardinfo {
      padding: 0 16px;
    }
  }

  @media screen and (max-width: 768px) {
    .maxwidth {
      margin: 0 5%;
      max-width: 90%;
      width: 90%;
    }

    .votingcardinfo {
      padding: 0 16px;
    }
  }

  span.titlestatus {
      font-size: 12px;
      font-weight: bold;
      color: #575757;
      line-height: 14px;
  }

  #descriptiontatus {
    padding: 0;
    margin: 0 28px 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Welcome.vue